import { gql } from "@apollo/client";
import {
  AUDIT_EVENT_FIELDS_FRAGMENT,
  HELP_REQUEST_FIELDS_FRAGMENT,
  HELP_REQUEST_MESSAGE_FIELDS_FRAGMENT,
  INCIDENT_COMMENT_FIELDS_FRAGMENT,
  INCIDENT_FIELDS_FRAGMENT,
} from "../../../common/model/fieldsFragment";

/* ---------- Incidents ---------- */

export const LIST_INCIDENTS = gql`
  query ListIncidents(
    $paginationParams: BaseCollection!
    $status: IncidentStatusEnum
    $priority: IncidentPriorityEnum
    $entityType: SupportEntityTypeEnum
    $assigneeId: String
  ) {
    QR_LIST_INCIDENT(
      paginationParams: $paginationParams
      status: $status
      priority: $priority
      entityType: $entityType
      assigneeId: $assigneeId
    ) {
      code
      data {
        totalElements
        totalPages
        currentPage
        kpi { openNb inProgressNB waitingOnCustomerNB resolved closed }
        content {
          incident { ...IncidentFields }
          request { ...HelpRequestFields }
        }
      }
    }
  }
  ${INCIDENT_FIELDS_FRAGMENT}
  ${HELP_REQUEST_FIELDS_FRAGMENT}
`;

export const GET_INCIDENT_KPI = gql`
  query IncidentKpi($paginationParams: BaseCollection!) {
    QR_LIST_INCIDENT(paginationParams: $paginationParams) {
      code
      data {
        totalElements
        kpi { openNb inProgressNB waitingOnCustomerNB resolved closed }
      }
    }
  }
`;

// Détail d'un ticket : incident + demande, commentaires internes et audit en un seul appel.
export const GET_INCIDENT_DETAIL = gql`
  query IncidentDetail($incidentId: String!) {
    QR_GET_INCIDENT(incidentId: $incidentId) {
      code
      data {
        incident { ...IncidentFields }
        request { ...HelpRequestFields }
      }
    }
    QR_LIST_INCIDENT_COMMENT(incidentId: $incidentId) {
      code
      data { content { ...IncidentCommentFields } }
    }
    QR_LIST_INCIDENT_EVENT(incidentId: $incidentId) {
      code
      data { content { ...AuditEventFields } }
    }
  }
  ${INCIDENT_FIELDS_FRAGMENT}
  ${HELP_REQUEST_FIELDS_FRAGMENT}
  ${INCIDENT_COMMENT_FIELDS_FRAGMENT}
  ${AUDIT_EVENT_FIELDS_FRAGMENT}
`;

export const ADD_INCIDENT_MUTATION = gql`
  mutation AddIncident($incidentInput: IncidentInput!) {
    MT_ADD_INCIDENT(incidentInput: $incidentInput) {
      code
      data { ...IncidentFields }
    }
  }
  ${INCIDENT_FIELDS_FRAGMENT}
`;

export const ASSIGN_INCIDENT_MUTATION = gql`
  mutation AssignIncident($incidentId: String!, $assigneeUpdateInput: IncidentAssigneeUpdateInput!) {
    MT_ASSIGN_INCIDENT(incidentId: $incidentId, assigneeUpdateInput: $assigneeUpdateInput) {
      code
      data { ...IncidentFields }
    }
  }
  ${INCIDENT_FIELDS_FRAGMENT}
`;

export const UPDATE_INCIDENT_PRIORITY_MUTATION = gql`
  mutation UpdateIncidentPriority($incidentId: String!, $priorityUpdateInput: IncidentPriorityUpdateInput!) {
    MT_UPDATE_INCIDENT_PRIORITY(incidentId: $incidentId, priorityUpdateInput: $priorityUpdateInput) {
      code
      data { ...IncidentFields }
    }
  }
  ${INCIDENT_FIELDS_FRAGMENT}
`;

export const ADD_INCIDENT_COMMENT_MUTATION = gql`
  mutation AddIncidentComment($incidentId: String!, $commentInput: IncidentCommentInput!) {
    MT_ADD_INCIDENT_COMMENT(incidentId: $incidentId, commentInput: $commentInput) {
      code
      data { ...IncidentCommentFields }
    }
  }
  ${INCIDENT_COMMENT_FIELDS_FRAGMENT}
`;

/* ---------- Demandes d'aide ---------- */

export const LIST_HELP_REQUESTS = gql`
  query ListHelpRequests(
    $paginationParams: BaseCollection!
    $status: HelpRequestStatusEnum
    $entityType: SupportEntityTypeEnum
    $requesterId: String
  ) {
    QR_LIST_HELP_REQUEST(
      paginationParams: $paginationParams
      status: $status
      entityType: $entityType
      requesterId: $requesterId
    ) {
      code
      data {
        totalElements
        totalPages
        currentPage
        content { ...HelpRequestFields }
      }
    }
  }
  ${HELP_REQUEST_FIELDS_FRAGMENT}
`;

// Le statut d'un ticket est porté par la demande d'aide (helpRequestId = incident.requestId).
export const UPDATE_HELP_REQUEST_STATUS_MUTATION = gql`
  mutation UpdateHelpRequestStatus($helpRequestId: String!, $statusUpdateInput: HelpRequestStatusUpdateInput!) {
    MT_UPDATE_HELP_REQUEST_STATUS(helpRequestId: $helpRequestId, statusUpdateInput: $statusUpdateInput) {
      code
      data { ...HelpRequestFields }
    }
  }
  ${HELP_REQUEST_FIELDS_FRAGMENT}
`;

/* ---------- Conversation d'une demande d'aide ---------- */

export const LIST_HELP_REQUEST_MESSAGES = gql`
  query HelpRequestMessages($helpRequestId: String!) {
    QR_LIST_HELP_REQUEST_MESSAGE(helpRequestId: $helpRequestId) {
      code
      data { content { ...HelpRequestMessageFields } }
    }
  }
  ${HELP_REQUEST_MESSAGE_FIELDS_FRAGMENT}
`;

export const ADD_HELP_REQUEST_MESSAGE_MUTATION = gql`
  mutation AddHelpRequestMessage($helpRequestId: String!, $messageInput: HelpRequestMessageInput!) {
    MT_ADD_HELP_REQUEST_MESSAGE(helpRequestId: $helpRequestId, messageInput: $messageInput) {
      code
      data { ...HelpRequestMessageFields }
    }
  }
  ${HELP_REQUEST_MESSAGE_FIELDS_FRAGMENT}
`;
